import styled, { css } from 'styled-components'

import SVGIcon from 'components/modules/common/SVGIcon/SVGIcon'

const TodoItem = ({ taskName, onCameraClick }) => {
  return (
    <TodoItemBackground>
      <TodoItemInner>
        <CameraBtn
          onClick={onCameraClick}
        >
          <SVGIcon name="camera" />
        </CameraBtn>
        <TaskName>{taskName}</TaskName>
      </TodoItemInner>
      <DashCircle />
      <Tooltip>클릭해서 인증!</Tooltip>
    </TodoItemBackground>
  )
}

const TodoItemBackground = styled.div`
  position: relative;
  z-index: 1;
  background-color: #ffffff;
  box-shadow: 0 calc(100vw * (2 / 375)) calc(100vw * (8 / 375)) rgba(133, 133, 133, 0.26);
  border-radius: calc(100vw * (14 / 375));
  width: 100%;
  height: calc(100vw * (60 / 375));
`

const TodoItemInner = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: calc(100vw * (9 / 375)) calc(100vw * (13 / 375));
`

const DashCircle = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: -1px;
  transform: translate(0, -50%);
  background: inherit;
  border: 2px dashed #ff9b57;
  border-radius: 50%;
  width: calc(100vw * (69 / 375));
  height: calc(100vw * (69 / 375));
`

const buttonStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100vw * (42 / 375));
  height: calc(100vw * (42 / 375));
  border-radius: 50%;
  margin-right: calc(100vw * (14 / 375));
`

const CameraBtn = styled.div`
  ${buttonStyle}
  background-color: #ffcf19;
  box-shadow: 0 1px calc(100vw * (10 / 375)) #fde698;

  svg {
    color: #ffffff;
    width: calc(100vw * (21 / 375));
  }
`

const TaskName = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
`

const Tooltip = styled.span`
  background-color: #FF6B00;
  color: #FFF;
  position: absolute;
  top: calc(100% + calc(100vw * (17 / 375)));
  left: calc(100vw * (5 / 375));
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  padding: calc(100vw * (10 / 375)) calc(100vw * (12 / 375));
  border-radius: calc(100vw * (5 / 375));

  &::after {
    content: " ";
    position: absolute;
    bottom: calc(100% - calc(100vw * (4 / 375)));
    left: calc(100vw * (16 / 375));
    border-width: calc(100vw * (4 / 375));
    border-style: solid;
    border-color: #FF6B00;
    border-top-left-radius: calc(100vw * (2 / 375));
    transform: rotate(45deg);
    z-index: -1;
  }
`

export default TodoItem
